import React from 'react';

import { useJobProspectsState, useJobProspectsActions } from './JobProspectsContext';
import { enrollInFreeTier, subscribeToPremium } from './restApi';
import Button from '../../Shared/UI/Button/components/Button';
import styles from './JobProspectsEnrollment.module.scss';

const JobProspectsEnrollment = () => {
  const state = useJobProspectsState();
  const {
    onResponse,
    onError,
    setEnrolled,
    setEnrolling,
    setSubscribing,
    openPaymentMethodModal,
  } = useJobProspectsActions();

  const enrolling = state?.enrolling;
  const subscribing = state?.subscribing;
  const hasPaymentMethod = state?.hasPaymentMethod;

  const authenticityToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content");

  const handleEnrollFree = () => {
    setEnrolling(true);
    enrollInFreeTier({
      onResponse: (data) => {
        setEnrolling(false);
        setEnrolled(true, 'free');
        onResponse(data);
      },
      onError: (data) => {
        setEnrolling(false);
        onError(data);
      },
      body: { authenticityToken },
    });
  };

  const handleSubscribePremium = () => {
    if (!hasPaymentMethod) {
      openPaymentMethodModal();
      return;
    }

    setSubscribing(true);
    subscribeToPremium({
      onResponse: (data) => {
        setSubscribing(false);
        setEnrolled(true, 'premium');
        onResponse({ ...data, tier: 'premium' });
      },
      onError: (data) => {
        setSubscribing(false);
        onError(data);
      },
      body: { authenticityToken },
    });
  };

  return (
    <div className={styles.enrollment}>
      <h2 className={styles.title}>Job Recommendations</h2>
      <p className={styles.subtitle}>
        Get AI-powered job recommendations matched to your skills, experience, and interests.
      </p>

      <div className={styles.tiers}>
        <div className={styles.tierCard}>
          <h3 className={styles.tierName}>Free</h3>
          <p className={styles.tierPrice}>$0/month</p>
          <ul className={styles.tierFeatures}>
            <li>Job recommendations once per month</li>
            <li>AI-matched to your profile</li>
          </ul>
          <Button
            variant="secondary"
            onClick={handleEnrollFree}
            disabled={enrolling || subscribing}
          >
            {enrolling ? 'Enrolling...' : 'Enroll in Free Tier'}
          </Button>
        </div>

        <div className={styles.tierCard}>
          <h3 className={styles.tierName}>Premium</h3>
          <p className={styles.tierPrice}>$19.99/month + applicable tax</p>
          <ul className={styles.tierFeatures}>
            <li>Daily AI-powered job matching</li>
            <li>30 AI-generated resumes per month, customized to each job</li>
          </ul>
          <Button
            variant="primary"
            onClick={handleSubscribePremium}
            disabled={enrolling || subscribing}
          >
            {subscribing ? 'Subscribing...' : 'Subscribe to Premium'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default JobProspectsEnrollment;
